/**
 * Reference Code Mapping for Geowall & Tobermore Walls
 * Maps field names to Evaluate codes (resourceCode in Item Library API)
 */

export interface GeoToberWallReferenceCodeMapping {
  code?: string;
}

/**
 * Geowall & Tobermore Walls Reference Codes
 * Maps field names from Geowall & Tobermore Walls tables to Evaluate codes
 */
export const GEO_TOBER_WALL_REFERENCES: Record<
  string,
  GeoToberWallReferenceCodeMapping
> = {
  // GEOWALLS - Excavation & Foundation
  excavateTrenchAndTipOnSite: { code: "GWALPGW0026" },
  compactFormation: { code: "GWALPGW0027" },
  concreteBlinding: { code: "GWALPGW0015" },
  a393Mesh: { code: "GWALPRM004" },
  a252Mesh: { code: "GWALPRM003" },
  b503Mesh: { code: "GWALPRM006" },
  b785Mesh: { code: "GWALPRM007" },
  concreteToFoundation: { code: "GWALPGW0013" },

  // GEOWALLS - Backfill & Drainage
  asDugBackfill: { code: "GWALP034" },
  stockpileOnsite: { code: "ALP033A" },
  perforated150mmPipe: { code: "GWALPGW0024" },
  concreteHaunchingToFront: { code: "GWALPGW0023" },
  concreteHaunchingToRear: { code: "GWALPGW0023" },
  granularBackfill: { code: "GWALPGW0032" },
  granularBackfill2: { code: "GWALPGW0032" },
  terram: { code: "GWALP014" },

  // GEOWALLS - Installation
  fencePostAt2400mmCcs: { code: "GWALPGW0022" },
  purchaseInclCarriageWasteFp: { code: "ZEV23" },
  installGeoWalls: { code: "GWALPGW0037" },

  // TOBERMORE - Excavation & Preparation
  excavateInCuttingsFp: {},
  excavationOfEmbankment: { code: "GWALPGW0026" },
  stockpileOnsiteTobermore: { code: "ALP033A" },
  batterToFaceOfEmbankment: { code: "GWALPGW0027" },
  excavationOfBase: { code: "GWALPGW0026" },
  stockpileOnsite2: { code: "ALP033A" },
  levelAndCompactFormation: { code: "GWALPGW0027" },
  concreteToBase: { code: "GWALPGW0013" },

  // TOBERMORE - Wall Installation
  tobermoreSupplyOfGrandSecuraInclFp: { code: "SCAANC007" },
  tobermoreSecuraInstallationByMj: { code: "GWALPGW0037" },
  tobermoreSupplyOfGeogrid: { code: "SCAANC007" },
  mjInstallationOfGeogrid: { code: "ALP032B" },
  installGeoWallsTobermore: {},
  fencePostAt2400mmCcsTobermore: { code: "GWALPGW0022" },

  // TOBERMORE - Backfill & Drainage
  freeDrainingGranularBackfill300wColumn: { code: "GWALPGW0032" },
  granularBackfillToRearOfWall: { code: "GWALPGW0032" },
  landDrainToRearOfWall: { code: "GWALPGW0024" },
  allowSiltTrap: { code: "GWALPDD019" },
  allowToConnectOfLandDrainToPlotDrainage: { code: "GWALPDD057" },
};

/**
 * Get reference code for a specific field
 */
export const getGeoToberWallReferenceCode = (
  referenceKey: string,
): string | undefined => {
  return GEO_TOBER_WALL_REFERENCES[referenceKey]?.code;
};

/**
 * Get full reference information for a specific field
 */
export const getGeoToberWallReference = (
  referenceKey: string,
): GeoToberWallReferenceCodeMapping | undefined => {
  return GEO_TOBER_WALL_REFERENCES[referenceKey];
};
